'use client'

import { ThemeContext } from 'context/theme.context'
import { FC, useContext, useEffect } from 'react'
import { useCompanySetting } from 'hooks/use.company.setting'
import { getDefaultDesign, SettingDesignType } from 'components/company/setting/types/setting.design.type'

export const DesignListener: FC = () => {
  const { value } = useCompanySetting<SettingDesignType>('design')

  const {customize, customizeToolbar, customizeSideMenu} = useContext(ThemeContext)

  useEffect(() => {
    const { overrides, ...root } = {
      ...getDefaultDesign(),
      ...(value ?? {} as SettingDesignType),
    }

    const toolbar = overrides?.find(o => o.type === 'toolbar')
    const sideMenu = overrides?.find(o => o.type === 'sideMenu')

    customize(root)
    if (toolbar) {
      customizeToolbar({
        ...root,
        ...toolbar,
      })
    } else {
      customizeToolbar(root)
    }

    if (sideMenu) {
      customizeSideMenu({
        ...root,
        ...sideMenu,
      })
    } else {
      customizeSideMenu(root)
    }
  }, [value])

  return null
}
